// use-fetch-suggestion.ts
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import type { Suggestion, SuggestionType } from '@/domain/dto/suggestion.dto';

export function useFetchSuggestions(projectId: number | null, suggestionType: SuggestionType) {
  const queryClient = useQueryClient();

  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ['suggestions', suggestionType, projectId],
    queryFn: async () => {
      if (!projectId) {
        // Caso projectId nulo, devolvemos arreglo vacío
        return [];
      }

      try {
        const res = await fetch(`/api/v2/suggestions/${suggestionType}/${projectId}`);
        if (!res.ok) {
          console.error(`Error en la petición: ${res.statusText}`);
          return [];
        }

        const response = await res.json();
        return response.data as Suggestion[];
      } catch (e) {
        console.error('Error al obtener sugerencias:', e);
        return [];
      }
    },
    enabled: !!projectId && !!suggestionType,
    staleTime: 1000 * 60 * 5,
  });

  const invalidateSuggestions = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: ['suggestions', suggestionType, projectId] });
    refetch();
  }, [queryClient, refetch, suggestionType, projectId]);

  return { data: data || [], error, isLoading, refetch, invalidateSuggestions };
}
